export function mapPriceConfiguratorV1(priceDetails, priceConfiguratorMode) {
  const future = new Date();

  future.setDate(future.getDate() + 30); // Mark the expiration date 30 days after the proposal got priced.
  // TODO: Move this logic into the backend to prevent errors with the user's local time.

  const totalTimberlineSolarHDZPrice = priceDetails.totalTimberlineSolarHDZPrice;

  const totalTimberlineSolarESPrice = priceDetails.totalTimberlineSolarESPrice;

  const commonPriceSettings = {
    itcRetailValue: priceDetails.itcRetailValue || 0,
    itcMarketValue: priceDetails.itcMarketValue || 0,
    proposalValidThroughDate: future.toLocaleDateString('sv'),
    additionalProjectCosts: Number(priceDetails.additionalProjectCosts) || 0,
    essentialsBackupPackageRooferPrice: priceDetails.essentialsBackupPackageRooferPrice,
    maxBackupPackageRooferPrice: priceDetails.maxBackupPackageRooferPrice,
  };

  if (priceConfiguratorMode) {
    // If we are in the simple view
    return {
      ...commonPriceSettings,
      customPricePerWatt: 0,
      totalPriceForTheHomeOwner: priceDetails.proposalTotal,
      totalTimberlineSolarHDZPrice: Number(totalTimberlineSolarHDZPrice),
      totalTimberlineSolarESPrice: Number(totalTimberlineSolarESPrice),
      timberlineSolarHDZPricePerSquare: 0,
      timberlineSolarHDZSquares: 0,
    };
  }

  return {
    ...commonPriceSettings,
    customPricePerWatt: Number(priceDetails.customPricePerWatt),
    totalPriceForTheHomeOwner: priceDetails.proposalTotal,
    totalTimberlineSolarHDZPrice: Number(totalTimberlineSolarHDZPrice),
    totalTimberlineSolarESPrice: Number(totalTimberlineSolarESPrice),
    timberlineSolarHDZPricePerSquare: Number(priceDetails.timberlineSolarHDZPricePerSquare),
    timberlineSolarHDZSquares: Number(priceDetails.timberlineSolarHDZSquares),
  };
}
